import React, { useState, useEffect } from 'react';
import Themes from '../Themes';
import translations from '../../translations';

function EditTentative({ updatedStartTime, updatedEndTime }) {
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'en');
  const t = translations[language];

  const theme = localStorage.getItem('theme');
  const tentative = localStorage.getItem('tentative');
  const selectedfontP = localStorage.getItem('fontP');
  
  const Components = Themes[theme];

  const heroStyle = {
    backgroundImage: `url(${Components.bg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  };

  function convertTo12HourFormat(time24) {
    const [hours, minutes] = time24.split(":");
    const period = hours >= 12 ? "pm" : "am";
    const hours12 = hours % 12 || 12; // Convert 0 to 12 for midnight
  
    return `${hours12}:${minutes} ${period}`;
  }

  const defaultData = [
    { title: "Kehadiran tetamu", displaytime: "11:30", time:"11:30"},
    { title: "Ketibaan Pengantin", displaytime: "12:30", time:"12:30"},
    { title: "Makan Beradab", displaytime: "1:30", time:"13:30"},
    { title: "Majlis Berakhir", displaytime: "4:30", time:"16:30"},
  ];

  const [aturCaraMajlis, setAturCaraMajlis] = useState(() => {
    return tentative ? JSON.parse(tentative) : defaultData;
  });

  useEffect(() => {
    localStorage.setItem('tentative', JSON.stringify(aturCaraMajlis));
    // console.log('tentative: ', JSON.stringify(aturCaraMajlis));
  }, [aturCaraMajlis]);

  const [isEditing, setIsEditing] = useState(false);

  const handleEditItem = (index, newTitle, newTime) => {
    const updatedAturCaraMajlis = [...aturCaraMajlis];
    updatedAturCaraMajlis[index].title = newTitle;
    updatedAturCaraMajlis[index].time = newTime;
    updatedAturCaraMajlis[index].displaytime = convertTo12HourFormat(newTime);
    setAturCaraMajlis(updatedAturCaraMajlis);
  };

  const handleAddItem = () => {
    const newItem = { title: t.newItem, time: "12:00 tengah hari" };
    setAturCaraMajlis([...aturCaraMajlis, newItem]);
  };

  const handleDeleteItem = (index) => {
    const updatedAturCaraMajlis = [...aturCaraMajlis];
    updatedAturCaraMajlis.splice(index, 1);
    setAturCaraMajlis(updatedAturCaraMajlis);
  };

  const handleMoveItemUp = (index) => {
    if (index > 0) {
      const updatedItems = [...aturCaraMajlis];
      const temp = updatedItems[index];
      updatedItems[index] = updatedItems[index - 1];
      updatedItems[index - 1] = temp;
      setAturCaraMajlis(updatedItems);
    }
  };

  const handleMoveItemDown = (index) => {
    if (index < aturCaraMajlis.length - 1) {
      const updatedItems = [...aturCaraMajlis];
      const temp = updatedItems[index];
      updatedItems[index] = updatedItems[index + 1];
      updatedItems[index + 1] = temp;
      setAturCaraMajlis(updatedItems);
    }
  };

  const fontP = selectedfontP;

  return (
    <div className="min-h-screen relative flex items-center justify-center" style={heroStyle}>
      <div className="text-center z-10 my-20">
        <div className={Components.tStyle}>
          <h1 className={`text-l mb-8 uppercase font-bold ${fontP}`}>{t.schedule}</h1>
          {isEditing ? (
            aturCaraMajlis.map((item, index) => (
              <div>
                <div key={index} className="my-4">
                  <input
                    type="text"
                    value={item.title}
                    onChange={(e) => {
                      handleEditItem(index, e.target.value, item.time);
                    }}
                    className='px-4 py-2 border text-gray-600 md:w-auto w-full'
                  />
                  <input
                    type="time"
                    value={item.time}
                    onChange={(e) => {
                      handleEditItem(index, item.title, e.target.value);
                    }}
                    className='px-4 py-2 border text-gray-600'
                  />
                  <button
                    onClick={() => handleDeleteItem(index)}
                    className="ml-5 bold text-neutral-50 px-4 py-2 bg-red-600"
                  >
                    X
                  </button>
                  <button
                    onClick={() => handleMoveItemUp(index)}
                    className="ml-2 bold text-neutral-50 px-4 py-2 bg-blue-600"
                  >
                    ↑
                  </button>
                  <button
                    onClick={() => handleMoveItemDown(index)}
                    className="ml-2 bold text-neutral-50 px-4 py-2 bg-blue-600"
                  >
                    ↓
                  </button>
                </div>
              </div>
            ))
          ) : (
            aturCaraMajlis.map((item, index) => (
              <div key={index}  className={`my-4 ${fontP}`}>
                <p className="text-l">{item.title}:</p>
                <p className="text-l">{item.displaytime}</p>
              </div>
            ))
          )}
          <div className='mb-5'>
            {isEditing && (
              <button
                onClick={handleAddItem}
                className="text-xl text-green-500 mt-4 border border-green-500 rounded-full px-3 py-1"
              >
                +
              </button>
            )}
          </div>
          <div>
            {isEditing && (
              <button onClick={() => setIsEditing(!isEditing)} className="text-neutral-50 px-4 py-2 bg-green-500 hover:bg-green-600 rounded-lg">
                {t.save}
              </button>
            )}

            {!isEditing && (
              <button onClick={() => setIsEditing(!isEditing)} className="text-sm text-blue-500">
                {t.changeSchedule}
              </button>
            )}
          </div>
        </div>
      </div>
      <img
        src={Components.ft}
        
        className={Components.ftStyle}
      />
      <img
        src={Components.fb}
        
        className={Components.fbStyle}
      />
    </div>
  );
}

export default EditTentative;
